<template>
  <div class="im-info-user__avatar">
    <div class="im-info-user__image">
      <img v-if="image" :src="image">
      <svg v-else>
        <use xlink:href="#icon-user"></use>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Avatar',
    props: {
      image: {
        type: String,
        default: null
      }
    }
  };
</script>

<style scoped>

</style>